// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__25WoJ","row":"styles_row__25Rz2"};